import { render, staticRenderFns } from "./modal-info-contact-row.vue?vue&type=template&id=76b65a35&"
import script from "./modal-info-contact-row.vue?vue&type=script&lang=js&"
export * from "./modal-info-contact-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports